export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-636.dcf28f7a.jpg";